// src/lib/http/bff.ts
import { createBffClient } from './bffClient';

const origin =
  typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000';

export const bff = createBffClient({
  origin,           // -> http://localhost:3000 (CRA dev)
  basePath: '/bff', // client will call /bff/*
  // timeoutMs, defaultHeaders, getAuthHeaders... (optional)
});
